export function getImageSize(src, size, seo = '') {
  return getImage(src, size, 'scale_crop', seo, '/smart');
}

export function getImagePreview(src, size, seo = '', filter = '/smart') {
  return getImage(src, size, 'scale_crop', seo, filter);
}

export function getImageContain(src, size, seo = '', filter = '') {
  return getImage(src, size, 'preview', seo, filter);
}

function getSize(size) {
  switch (size) {
    case 'small':
      return '60x60';
    case 'medium':
      return '325x303';
    case 'medium_l':
      return '496x310';
    case 'big':
      return '666x416';
    default:
      return size; // can still provide a different dimension when needed - not recommended
  }
}

function getImage(src, size, mode = 'scale_crop', seo = '', filter = '') {
  if (!size) return src;
  if (src && src.indexOf('ucdn') !== -1) {
    const dimensions = getSize(size);

    const newValue = `-/quality/better/-/${mode}/${dimensions}${filter}/${seo}`;

    if (src.indexOf('-/preview/200x200/') !== -1) {
      src = src.replace('-/preview/200x200/', newValue);
    } else if (src.indexOf('-/scale_crop/200x200/smart/') !== -1) {
      src = src.replace('-/scale_crop/200x200/smart/', newValue);
    } else if (src.indexOf('-/scale_crop/200x200/') !== -1) {
      src = src.replace('-/scale_crop/200x200/', newValue);
    } else {
      src += newValue;
    }
  }
  return src;
}
